const EntertainUseComponent = () => import('@/views/finance/EntertainUse/EntertainUseView')

export default [
    {
        path:'/EntertainUseIndex',
        name:'EntertainUseComponent',
        component:EntertainUseComponent
    }
]